import clsx from "clsx";
import { forwardRef, memo } from "react";

import classes from "../../styles.module.scss";

import type { ITableContainerProps } from "@components/organisms/pageTable";

export const TableContainer = memo(
  forwardRef<HTMLDivElement, ITableContainerProps>(function TableContainer(
    { children },
    ref,
  ) {
    return (
      <div ref={ref} className={clsx(classes.pageTable__container)}>
        {children}
      </div>
    );
  }),
);

TableContainer.displayName = "TableContainer";
